import { useResourceContext, useRecordContext } from 'react-admin';
import { useSubscribe } from './useSubscribe';
export var useSubscribeToLock = function (subscriptionCallback, resource, id, options) {
    var actualResource = useResourceContext({ resource: resource });
    var record = useRecordContext();
    useSubscribe(id || record ? "lock/".concat(actualResource, "/").concat(id || (record === null || record === void 0 ? void 0 : record.id)) : null, subscriptionCallback, options);
};
